import { render, staticRenderFns } from "./MatchQuestionPackageList.vue?vue&type=template&id=4793c1bd"
import script from "./MatchQuestionPackageList.vue?vue&type=script&lang=js"
export * from "./MatchQuestionPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports